import { AbilityContext } from "@context/can";
import { useContext } from "react";
import useLogout from "@hooks/use-logout";
import { ProductContext } from "@src/utility/context/product";

// ** Merge & Export
const useNavigation = () => {
    const ability = useContext(AbilityContext);
    const { handleLogout } = useLogout();
    const { platformId } = useContext(ProductContext);
    
    return {
        superadmin: [
            {
                id      : "organizations",
                title   : "Organizations",
                icon    : "companies",
                navLink : "/superadmin/organizations",
                resource: "organizations",
                testId  : "organizations",
                show    : ability.can("read", "organizations")
            }
        ],
        panel: [
            {
                id      : "dashboard",
                title   : "Dashboard",
                icon    : "dashboard",
                navLink : `dashboard/${platformId}`,
                resource: "dashboard",
                testId  : "dashboard",
                show    : ability.can("read", "dashboard")
            },
            // /** Engagements */
            // {
            //     header  : "Analyze",
            //     resource: "reports",
            //     show    : ability.can("read", "reports")
            // },
            /** Reports */
            {
                id      : "reports",
                title   : "Reports",
                icon    : "reports",
                resource: "reports",
                testId  : "reports",
                show    : ability.can("read", "reports"),
                children: [
                    {
                        id      : "team-performance",
                        title   : "Team Performance",
                        icon    : "",
                        navLink : `/product/${platformId}/reports/team-performance`,
                        resource: "reports",
                        testId  : "reports",
                        show    : ability.can("read", "reports")
                    },
                    {
                        id      : "revenue",
                        title   : "Revenue",
                        icon    : "",
                        navLink : `/product/${platformId}/reports/revenue`,
                        resource: "reports",
                        testId  : "reports",
                        show    : ability.can("read", "reports")
                    },
                    {
                        id      : "retention",
                        title   : "Retention",
                        icon    : "",
                        navLink : `/product/${platformId}/reports/retention`,
                        resource: "reports",
                        testId  : "reports",
                        show    : ability.can("read", "reports")
                    },
                    {
                        id      : "churn",
                        title   : "Churn",
                        icon    : "",
                        navLink : `/product/${platformId}/reports/churn`,
                        resource: "reports",
                        testId  : "reports",
                        show    : ability.can("read", "reports")
                    },
                    {
                        id      : "onboarding-won",
                        title   : "Onboarding",
                        icon    : "",
                        navLink : `/product/${platformId}/reports/onboarding-won`,
                        resource: "reports",
                        testId  : "reports",
                        show    : ability.can("read", "reports")
                    }
                ]
            },
            {
                id      : "companies",
                title   : "Companies",
                icon    : "companies",
                navLink : `/product/${platformId}/companies`,
                resource: "companies",
                testId  : "companies",
                show    : ability.can("read", "companies")
            },
            /** Segments */
            {
                id      : "segments",
                title   : "Segments",
                icon    : "segments",
                navLink : `/product/${platformId}/segments`,
                resource: "segments",
                testId  : "segments",
                show    : ability.can("read", "segments")
            },
            /** Life Cycle */
            {
                id      : "life-cycle",
                title   : "Life Cycle",
                icon    : "life-cycle",
                navLink : `/product/${platformId}/life-cycle`,
                resource: "life-cycle",
                testId  : "life-cycle",
                show    : ability.can("read", "life-cycle")
            },
            /** Health Scores */
            {
                id      : "health-scores",
                title   : "Health Scores",
                icon    : "health-scores",
                navLink : `/product/${platformId}/health-scores`,
                resource: "health-scores",
                testId  : "health-scores",
                show    : ability.can("read", "health-scores")
            },
            /** Surveys */
            {
                id      : "surveys",
                title   : "Surveys",
                icon    : "surveys",
                navLink : `/product/${platformId}/surveys`,
                resource: "surveys",
                testId  : "surveys",
                show    : ability.can("read", "surveys")
            },
            /** Playbooks */
            {
                id      : "playbooks",
                title   : "Playbooks",
                icon    : "playbooks",
                navLink : `/product/${platformId}/playbooks`,
                resource: "playbooks",
                testId  : "playbooks",
                show    : ability.can("read", "playbooks")
            },
            /** Calculated Metrics */
            {
                id      : "calculated-metrics",
                title   : "Calculated Metrics",
                icon    : "calculated-metrics",
                navLink : `/product/${platformId}/calculated-metrics`,
                resource: "calculated-metrics",
                testId  : "calculated-metrics",
                show    : ability.can("read", "calculated-metrics")
            },
            {
                id      : "plans",
                title   : "Plans",
                icon    : "plans",
                navLink : `/product/${platformId}/plans`,
                resource: "plans",
                testId  : "plans",
                show    : ability.can("read", "plans")
            },
            {
                id      : "custom-fields",
                title   : "Custom Fields",
                icon    : "custom-fields",
                navLink : `/product/${platformId}/custom-fields`,
                resource: "custom-fields",
                testId  : "custom-fields",
                show    : ability.can("read", "custom-fields")                    
            }
        ],
        bottomNavigation: [
            {
                id      : "settings",
                title   : "Settings",
                icon    : "settings",
                navLink : "/settings",
                resource: "settings",
                testId  : "settings",
                show    : ability.can("read", "settings"),
                children: [
                    {
                        id      : "users",
                        title   : "Users",
                        navLink : "/settings/users",
                        resource: "settings",
                        testId  : "users",
                        show    : false
                    },
                    {
                        id      : "stages",
                        title   : "Stages",
                        navLink : `/product/${platformId}/settings/stages`,
                        resource: "settings",
                        testId  : "stages",
                        show    : ability.can("read", "settings")
                    },
                    {
                        id      : "subscriptions",
                        title   : "Subscriptions",
                        navLink : `/product/${platformId}/settings/subscriptions`,
                        resource: "settings",
                        testId  : "subscriptions",
                        show    : ability.can("read", "settings")
                    },
                    {
                        id      : "invoices",
                        title   : "Invoices",
                        navLink : `/product/${platformId}/settings/invoices`,
                        resource: "settings",
                        testId  : "invoices",
                        show    : ability.can("read", "settings")
                    },
                    {
                        id      : "tags",
                        title   : "Tags",
                        navLink : `/product/${platformId}/settings/tags`,
                        resource: "settings",
                        testId  : "tags",
                        show    : ability.can("read", "settings")
                    },
                    {
                        id      : "kpi",
                        title   : "KPI",
                        navLink : `/product/${platformId}/settings/kpi`,
                        resource: "settings",
                        testId  : "kpi",
                        show    : ability.can("read", "settings")
                    },
                    {
                        id      : "apikey",
                        title   : "API Key",
                        navLink : "/settings/apikey",
                        resource: "settings",
                        testId  : "apikey",
                        show    : ability.can("read", "settings")
                    },
                    {
                        id      : "templates",
                        title   : "Templates",
                        navLink : `/product/${platformId}/settings/templates`,
                        resource: "settings",
                        testId  : "templates",
                        show    : ability.can("read", "settings")
                    }
                ]
            },
            {
                id      : "logout",
                title   : "Logout",
                icon    : "logout",
                resource: "settings",
                testId  : "logout",
                show    : true,
                onClick : () => {
                    handleLogout();
                }
            }
        ],
        account: [
            {
                id      : "dashboard",
                title   : platformId ? "Back to Dashboard" : "Back to Products",
                icon    : "back_to_dashboard",
                navLink : platformId ? `/dashboard/${platformId}` : "/account/platforms",
                resource: "dashboard",
                testId  : "dashboard",
                show    : ability.can("read", "dashboard")
            },
            /** Users */
            {
                id      : "users",
                title   : "Users",
                icon    : "users",
                navLink : "/account/users",
                resource: "users",
                testId  : "users",
                show    : ability.can("read", "users")
            },

            /** My Accounts */
            {
                id      : "account",
                title   : "My Account",
                icon    : "my_account",
                navLink : "/account/myaccount",
                resource: "settings",
                testId  : "account",
                show    : ability.can("read", "settings")
            }
        ]
    };
};

export default useNavigation;
